<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { NestMonsterType } from '@/types/monster'
import { ref } from 'vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import WildMap from './WildMap.vue'
import { dayjs } from 'element-plus'

const userStore = useUserStore()

defineProps<{ monster?: NestMonsterType }>()
const emits = defineEmits(['start'])

const isEnter = ref(false)
function handleEnter() {
  if (userStore.soulType > 3) return ElMessage.warning('二觉后无法参与大荒野')
  isEnter.value = true
}
const WildMapRef = ref()
</script>

<template>
  <div class="border-wrap big-wild">
    <h4 style="color: #e0c38c">
      大荒野
      <div class="help-info" style="margin-left: 5px">
        <el-popover placement="top" width="100%" trigger="click">
          <template #reference>
            <el-icon size="20"><QuestionFilled /></el-icon>
          </template>
          <div class="affix">
            <h4>大荒野说明</h4>
            <p>1. 大荒野<span class="info">每月1日0点刷新</span>，届时将重置大荒野。</p>
            <p>
              2. 当您在当月首次进入大荒野后，将每日获得 2<span class="info">体力</span>（会员为
              3），用于大荒野的探索及挑战，请留意体力达到上限时，将不再回复。
            </p>
            <p>
              3. 大荒野由多个图块组成，从内至外难度将逐步提升，每月在最外圈都存在一个<span class="gold">宝藏点</span>，击败宝藏点首领将获得大量奖励。
            </p>
            <p>4. 大荒野支持<span class="info">切换装备立即生效</span>，合理的切换装备进行挑战将事半功倍。</p>
            <p>5. 奖励规则（购买<span class="info">寻宝熏香</span>可必定获得<span class="grow">最大值</span>的奖励）：</p>
            <template v-if="dayjs().isAfter(dayjs('2025-09-01'))">
              <p style="text-indent: 2em">a. 第二圈奖励：<span class="pet">4 阶魔物</span></p>
              <p style="text-indent: 2em">b. 第三圈奖励：<span class="info">2~8 锻造石</span></p>
              <p style="text-indent: 2em">c. 第四圈奖励：<span class="info">1~5 潜能石</span></p>
              <p style="text-indent: 2em">
                d. 宝藏点奖励：<span class="antiquity">1 远古之魂</span>、<span class="info">5~20 锻造石</span>、<span class="info">4~12 潜能石</span>
              </p>
            </template>
            <template v-else>
              <p style="text-indent: 2em">a. 第二圈奖励：<span class="pet">4 阶魔物</span></p>
              <p style="text-indent: 2em">b. 第三圈奖励：<span class="info">2~5 锻造石</span></p>
              <p style="text-indent: 2em">c. 第四圈奖励：<span class="info">1~3 潜能石</span></p>
              <p style="text-indent: 2em">
                d. 宝藏点奖励：<span class="antiquity">1 远古之魂</span>、<span class="info">5~10 锻造石</span>、<span class="info">4~8 潜能石</span>
              </p>
            </template>
          </div>
        </el-popover>
      </div>
    </h4>
    <div style="margin: 10px 0">
      <el-button type="success" plain @click="handleEnter" :disabled="!userStore.soulType">
        {{ !userStore.soulType ? '觉醒后解锁' : '进入' }}
      </el-button>
    </div>

    <WildMap ref="WildMapRef" v-if="isEnter" @start="(res) => emits('start', res)" @back="isEnter = false" />
  </div>
</template>

<style lang="scss" scoped>
.big-wild {
  flex-flow: column;
}
</style>
